
import React from 'react';
import { Clock, FileSignature, Trash2 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';

export interface ChatHistoryItemProps {
  id: string;
  title: string;
  updated_at: string;
  has_signed_document?: boolean;
  onOpenChat: (chatId: string) => void;
  onDeleteClick: (e: React.MouseEvent, chatId: string) => void;
}

export const formatChatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    return format(date, "dd. MMMM yyyy, HH:mm", { locale: de });
  } catch (error) {
    return "Unbekanntes Datum";
  }
};

const ChatHistoryItem: React.FC<ChatHistoryItemProps> = ({
  id,
  title,
  updated_at,
  has_signed_document = false,
  onOpenChat,
  onDeleteClick
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="relative group">
            <button
              className="w-full text-left px-2 py-1.5 rounded-md hover:bg-gray-800 text-gray-300 transition-colors text-sm truncate"
              onClick={() => onOpenChat(id)}
            >
              <div className="flex items-center">
                {has_signed_document ? (
                  <FileSignature className="h-3.5 w-3.5 mr-2 text-jade" />
                ) : (
                  <Clock className="h-3.5 w-3.5 mr-2 text-gray-400" />
                )}
                <span className="truncate">
                  {title || "Konversation vom " + new Date(updated_at).toLocaleDateString()}
                </span>
              </div>
            </button>
            <button 
              className="absolute right-1 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 p-1 hover:bg-gray-700 rounded-full text-gray-400 hover:text-red-400 transition-all"
              onClick={(e) => onDeleteClick(e, id)}
              aria-label="Chat löschen"
            >
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>{title}</p>
          {has_signed_document && (
            <p className="text-jade text-xs">Enthält signierte Dokumente</p>
          )}
          <p className="text-xs text-gray-400">{formatChatDate(updated_at)}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ChatHistoryItem;
